var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.value.customerName))]),_c('div',[_vm._v(_vm._s(!!_vm.value.idKey ? 'IČ: ' + _vm.value.idKey : ''))]),_c('div',[_vm._v(_vm._s(!!_vm.value.countryId ? 'DIČ: ' + _vm.value.countryId : ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }